import React from 'react';
import Layout from '../../../components/Layout.jsx';
import DealForm from './_Form.jsx';

export default function SuperadminDealsNew({
  deal, available_items = [], available_facility_types = [], available_plans = [],
  errors = [], facility_search_path = null,
}) {
  return (
    <Layout>
      <div className="max-w-2xl mx-auto p-6 sm:p-8 space-y-6">
        <div>
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 mb-2 rounded-full bg-purple-50 text-purple-700 border border-purple-200 text-xs font-medium">
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            Superadmin
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">New deal</h1>
          <p className="mt-1 text-sm text-gray-500">
            You'll get a shareable link once it's saved. Deals can't be edited afterwards — the link may
            already be with a customer, so changing the terms would move the goalposts underneath them.
          </p>
        </div>

        <DealForm
          deal={deal}
          availableItems={available_items}
          availableFacilityTypes={available_facility_types}
          availablePlans={available_plans}
          errors={errors}
          facilitySearchPath={facility_search_path}
        />
      </div>
    </Layout>
  );
}
